// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","751":"component---src-templates-blog-post-js","970":"component---src-pages-about-tsx"}[chunkId] + "-" + {"245":"7a62ea3acdfa11b31b24","453":"eef609014b491af11804","751":"8eaba96d8cc3a34105cb","970":"e69f9660189a5de72fad"}[chunkId] + ".js";
};